<div class="d-flex flex-row justify-content-center" [class.center-vertically]="centerVertically" [class.align-items-center]="centerVertically">
    <div class="sp sp-circle"></div>
</div>